import { Chip } from '@mui/material';

import type { DataSource } from '../../config/capabilities';

const labels: Readonly<Record<DataSource, string>> = {
  mock: 'Mock Data',
  real: 'Live Data',
  unavailable: 'Unavailable',
};

export function DataSourceBadge({ source }: { readonly source: DataSource }) {
  return (
    <Chip
      aria-label={`Data source: ${labels[source]}`}
      color={source === 'mock' ? 'secondary' : source === 'real' ? 'success' : 'default'}
      label={labels[source]}
      size="small"
      variant={source === 'real' ? 'outlined' : 'filled'}
    />
  );
}
